export enum BrokerSecurityTypeEnum {
    EQUITY = 1,
    OPTION = 2,
}
